export default __webpack_public_path__ + "static/media/permata.ddff0a9f.png";